export default "/v8.64.0/120d74a/bundles/manifest.json";